<template>
  <div v-if="serviceInView !== undefined">
    <div class="service-details">
      <h3>{{ serviceInView.name }}</h3>
      <p>{{ serviceInView.description }}</p>
      <p
        class="info"
        v-if="
          serviceInView.additionalInfo && serviceInView.additionalInfo.length
        "
        v-html="htmlDecode(serviceInView.additionalInfo)"
      ></p>
    
    </div>
    <button
      v-if="isSelected"
      class="error"
      @click="removeFromReservation(serviceInView)"
    >
      {{ t.getOrKey("Button.RemoveService") }}
    </button>
    <button v-else class="primary" @click="addToReservation(serviceInView)">
      {{ t.getOrKey("Button.AddServiceAndContinue") }}
    </button>
  </div>
</template>
<script>
import t from "@/services/translation-service";
import utils from "@/services/utils.js";

export default {
  props: {
    serviceInView: Object,
    selectedServices: Array,
  },
 
  watch: {
    serviceInView() {},
  },
  data() {
    return {
      t: t,
      isValidToAdd: undefined,
    };
  },
  computed: {
    isSelected() {
      return this.selectedServices.some((s) => s.id === this.serviceInView.id);
    },
  },
  methods: {
    htmlDecode: utils.htmlDecode,   
    addToReservation(service) {
      if (!this.isSelected) {
        
          const selected = utils.clone(this.selectedServices);
          selected.push(service);
          this.$emit("selectedChange", selected);
        }
      }    ,
    removeFromReservation(service) {
      this.$emit("removeFromReservation", service);
    },
  },
};
</script>
<style>
.info {
  border-color: #bce8f1;
  margin-bottom: 20px;
  border: 1px solid transparent;
  background-color: #f1f1f1;
  padding: 1rem;
  border-radius: 0;
  width: 100%;
  white-space: pre-wrap;
}
</style>
